<template>
  <div class="mt-3">
    <b-form>
      <b-row>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Confirm Email</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group label-for="input-1">
            <b-form-input
              :state="true"
              v-model="exportReportForm.confirmEmail"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <b-row class="mt-3">
        <b-col xl="6" md="6" sm="6">
          <div class="float-left">
            <base-button type="white" title="Close"  v-on:click="modalClose()">
							  Close
						</base-button>
          </div>
        </b-col>
        <b-col xl="6" md="6" sm="6">
          <div class="float-right">
            <base-button type="primary" title="Send"  v-on:click="submitExportReportFunc">
              Send
						</base-button>
          </div>
        </b-col>
      </b-row>

    </b-form>
  </div>
</template>

<script>
  import submitExportReportFunc from "../../common/api-services/reports-dashboard-service";
  import initService from "../../common/api-services/init-service";

  export default {
    name: "Export-Report",
    components: {},
    data() {
      return {
        exportReportForm: {
          confirmEmail: ''
        },
        reportName: '',
        reportPeriod: ''
      }
    },
    mounted() {
      this.getCustomerEmail();

      this.$root.$on('exportReportData', (data => {
        this.reportName = data.reportName;
        this.reportPeriod = data.reportPeriod;
      }))
    },
    methods: {
      getCustomerEmail() {
        this.exportReportForm.confirmEmail =  initService.getCustomerEmailInfo()
      },

      modalClose() {
        this.$bvModal.hide('export-report')
      },

      submitExportReportFunc() {
        submitExportReportFunc.submitExportReport(this.reportName, this.reportPeriod, this.exportReportForm.confirmEmail).then(res => {
          this.$toast.success('We are exporting! We will mail you once it is ready')
        });
        this.modalClose()
      },

    }
  }
</script>
